import WebsiteBehaviors from "../website-behaviors/index.js";

class Wiley extends WebsiteBehaviors {
	identifier() {
		return "Wiley";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "aapm.onlinelibrary.wiley.com");
	}
}

export default Wiley;
